/**
 * Schema.org Event JSON-LD for Nick Fraser: Chapter 2.
 * Injected once at the top of the React tree so search engines (Google,
 * Bing) can show the exhibition as a rich event result — date, venue,
 * ticket link, organiser, image.
 *
 * Reference: https://schema.org/Event
 */
import { useEffect } from "react";

const SCHEMA = {
  "@context": "https://schema.org",
  "@type": "ExhibitionEvent",
  name: "Nick Fraser: Chapter 2",
  description:
    "A one-day exhibition from the Estate of Nick Fraser (1946–2023) at Shoreditch Arts Club — selected original works, immersive projection, archive film, cinema screening and the first public release of limited-edition Nick Fraser prints.",
  startDate: "2026-07-31T12:00:00+01:00",
  endDate: "2026-07-31T22:30:00+01:00",
  eventStatus: "https://schema.org/EventScheduled",
  eventAttendanceMode: "https://schema.org/OfflineEventAttendanceMode",
  location: {
    "@type": "Place",
    name: "Shoreditch Arts Club",
    address: {
      "@type": "PostalAddress",
      streetAddress: "6 Redchurch Street",
      addressLocality: "London",
      postalCode: "E2 7DD",
      addressCountry: "GB",
    },
  },
  image: [
    "https://chapter2.nickfraserartist.com/posters/chapter-2.jpg",
    "https://chapter2.nickfraserartist.com/release/tribal.jpg",
  ],
  performer: {
    "@type": "Person",
    name: "Nick Fraser",
    birthDate: "1946",
    deathDate: "2023",
    description:
      "Self-taught British outsider artist from London's East End.",
  },
  organizer: {
    "@type": "Organization",
    name: "The Nick Fraser Estate",
    url: "https://chapter2.nickfraserartist.com",
  },
  offers: [
    {
      "@type": "Offer",
      name: "Day Viewing — 12:00pm",
      url: "https://www.nickfraserartist.com/event-details/nick-fraser-chapter-2",
      price: "10.00",
      priceCurrency: "GBP",
      availability: "https://schema.org/InStock",
      validFrom: "2026-04-01T00:00:00+01:00",
    },
    {
      "@type": "Offer",
      name: "Day Viewing — 1:00pm",
      url: "https://www.nickfraserartist.com/event-details/nick-fraser-chapter-2",
      price: "10.00",
      priceCurrency: "GBP",
      availability: "https://schema.org/InStock",
      validFrom: "2026-04-01T00:00:00+01:00",
    },
    {
      "@type": "Offer",
      name: "Day Viewing — 2:00pm",
      url: "https://www.nickfraserartist.com/event-details/nick-fraser-chapter-2",
      price: "10.00",
      priceCurrency: "GBP",
      availability: "https://schema.org/InStock",
      validFrom: "2026-04-01T00:00:00+01:00",
    },
    {
      "@type": "Offer",
      name: "Evening Private View — 7:00pm",
      url: "https://www.nickfraserartist.com/event-details/nick-fraser-chapter-2",
      price: "15.00",
      priceCurrency: "GBP",
      availability: "https://schema.org/InStock",
      validFrom: "2026-04-01T00:00:00+01:00",
    },
  ],
  url: "https://chapter2.nickfraserartist.com",
};

export default function EventSchema() {
  useEffect(() => {
    const id = "nf-event-schema";
    let el = document.getElementById(id);
    if (!el) {
      el = document.createElement("script");
      el.id = id;
      el.type = "application/ld+json";
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(SCHEMA);
    return () => {
      const node = document.getElementById(id);
      if (node) node.remove();
    };
  }, []);
  return null;
}
